<app-new-dashboard-header tab="home" [workplace]="workplace"></app-new-dashboard-header>
<div class="govuk-width-container govuk-!-margin-top-7">
  <app-alert></app-alert>
  <app-summary-section
    [canViewListOfWorkers]="canViewListOfWorkers"
    [workplace]="workplace"
    [workerCount]="workerCount"
    [workersCreatedDate]="workersCreatedDate"
    [trainingCounts]="trainingCounts"
    [workersNotCompleted]="workersNotCompleted"
    [(navigateToTab)]="navigateToTab"
    [canViewEstablishment]="canViewEstablishment"
    [canEditEstablishment]="canEditEstablishment"
    [canEditWorker]="canEditWorker"
    [noOfWorkersWhoRequireInternationalRecruitment]="noOfWorkersWhoRequireInternationalRecruitment"
    [noOfWorkersWithCareWorkforcePathwayCategoryRoleUnanswered]="
      noOfWorkersWithCareWorkforcePathwayCategoryRoleUnanswered
    "
    [noOfWorkersWithDelegatedHealthcareUnanswered]="noOfWorkersWithDelegatedHealthcareUnanswered"
    [showCheckCqcDetails]="showCheckCqcDetails"
  ></app-summary-section>
</div>
<div class="govuk-width-container govuk-!-margin-top-7" data-cy="cards-and-links">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-two-thirds">
      <div class="govuk-grid-row">
        <div *ngIf="canViewReports" class="govuk-grid-column-one-half govuk-!-padding-right-1">
          <app-card [image]="'/assets/images/wdf.svg'">
            <a
              class="govuk-link--no-visited-state govuk-!-font-size-19 govuk-!-font-weight-bold"
              routerLink="/funding"
              href="#"
              >Does your data meet funding requirements?</a
            >
            <p class="govuk-!-margin-top-5">
              Update your data so that you can claim money back against the costs of training your staff.
            </p></app-card
          >
        </div>

        <div class="govuk-grid-column-one-half govuk-!-padding-left-1">
          <app-card [image]="'/assets/images/benchmarks.svg'">
            <a
              (click)="navigateToTab($event, 'benchmarks')"
              class="govuk-link--no-visited-state govuk-!-font-size-19 govuk-!-font-weight-bold"
              href="#"
            >
              <ng-container *ngIf="bigThreeServices && hasBenchmarkComparisonData; else notBigThreeServices">
                See how your pay, recruitment and retention compares against other workplaces</ng-container
              >
              <ng-template #notBigThreeServices> See how you compare against other workplaces</ng-template>
            </a>
            <p class="govuk-!-margin-top-5">
              {{ benchmarksMessage }}
            </p>
          </app-card>
        </div>
      </div>
    </div>
    <div class="govuk-grid-column-one-third">
      <app-new-article-list data-testid="article-list"></app-new-article-list>
      <app-other-links
        [canBulkUpload]="canBulkUpload"
        [canViewReports]="canViewReports"
        [isParentSubsidiaryView]="false"
        [canBecomeAParent]="canBecomeAParent"
        [canLinkToParent]="canLinkToParent"
        [isParent]="workplace.isParent"
        [linkToParentRequestedStatus]="linkToParentRequestedStatus"
        [parentStatusRequested]="parentStatusRequested"
        [canViewChangeDataOwner]="canViewChangeDataOwner"
        [isOwnershipRequested]="isOwnershipRequested"
        [canViewDataPermissionsLink]="canViewDataPermissionsLink"
        [canRemoveParentAssociation]="canRemoveParentAssociation"
        [canViewChangeDataOwner]="canViewChangeDataOwner"
        (ownershipChangeMessageEvent)="ownershipChangeMessage($event)"
        (cancelChangeDataOwnerRequestEvent)="cancelChangeDataOwnerRequest($event)"
      ></app-other-links>
    </div>
  </div>
</div>
